import React from "react";
import Button from "Components/button/Button";
import { QRCodeSVG, QRCodeCanvas } from "qrcode.react";

import { alertError, alertSuccess } from "Utils/alerts";
import TranslatedString from "Components/TranslatedString";
import Pin from "Components/pin/Pin";
import t from "Utils/translation";
import { Icon, appleStore, googlePlayStore } from "Icons/index";
import { view, store } from "@risingstack/react-easy-state";
import QboxmailApi from "@/qboxmailApi";

import cx from "classnames";
import s from "./OTPConfig.scss";

class OtpConfig extends React.Component {
  api = new QboxmailApi({ useCookie: true });

  otpState = store({
    generatingSecret: false,
    copied: false,
    verifingOTP: false,
    invalidOTP: false,
  });

  generateSecret = async () => {
    // reset copied message, the new secret it is not copied in clipboard
    this.otpState.copied = false;
    this.otpState.generatingSecret = true;
    const resp = await this.api.generateOTPSecret(this.props.user.code);
    this.otpState.generatingSecret = false;
    this.otpState.secret = resp.otp_secret;
  };

  verify = async (action) => {
    this.otpState.invalidOTP = false;
    if (action !== "enable" && action !== "disable") throw "Invalid action";

    this.otpState.verifingOTP = true;
    let resp;
    try {
      resp = await this.api.verifyOTP(this.props.user.code, this.pin.getValue(), action);
    } catch (e) {
      if (e.status === 422) {
        this.otpState.verifingOTP = false;
        this.otpState.invalidOTP = true;
        alertError(t("alert.otpInvalid"));
      } else {
        throw e;
      }

      return;
    }

    // alert success and close the modal
    alertSuccess(t("alert.otpValid"));
    this.props.onSuccess();
    this.otpState.verifingOTP = false;
  };

  renderGoogleAuth() {
    return (
      <div className={s.wrapApp}>
        <div className={s.text}>
          <TranslatedString>modal.otp.app.desc</TranslatedString>
        </div>
        <div className={s.appName}>
          <div className={s.iconApp}>
            <img
              alt="google-autheticator-logo"
              src="https://lh3.googleusercontent.com/HPc5gptPzRw3wFhJE1ZCnTqlvEvuVFBAsV9etfouOhdRbkp-zNtYTzKUmUVPERSZ_lAL=w300"
            />
          </div>
          <div className={s.textApp}>Google Authenticator®</div>
        </div>
        <div className={s.osAppLink}>
          <div className={s.storeBadge} onClick={() => window.open("https://goo.gl/KkWR1s")}>
            <Icon
              className={s.iconSB}
              svg={googlePlayStore}
              width="1.5rem"
              height="1.5rem"
              onClick={() => window.open("https://goo.gl/KkWR1s")}
            />
            <div className={s.wrapTextSB}>
              <div className={s.ctaStore}>Get it on</div>
              <div className={s.nameStore}>Google Play</div>
            </div>
          </div>

          <div className={s.storeBadge} onClick={() => window.open("https://goo.gl/kwHxnL")}>
            <Icon
              className={s.iconSB}
              svg={appleStore}
              width="1.5rem"
              height="1.5rem"
              onClick={() => window.open("https://goo.gl/KkWR1s")}
            />
            <div className={s.wrapTextSB}>
              <div className={s.ctaStore}>Download on</div>
              <div className={s.nameStore}>App Store</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderGoogleAuthFooter() {
    return (
      <div className={s.footer}>
        {!this.props.cantClose && (
          <Button color="text" onClick={this.props.onCancel}>
            button.cancel
          </Button>
        )}

        <Button loading={this.otpState.generatingSecret} onClick={this.generateSecret}>
          button.enable
        </Button>
      </div>
    );
  }

  renderEnableFooter() {
    return (
      <div className={s.footer}>
        {!this.props.cantClose && (
          <Button color="text" onClick={this.props.onCancel}>
            button.cancel
          </Button>
        )}

        <Button color="green" loading={this.otpState.verifingOTP} onClick={() => this.verify("enable")}>
          button.confirm
        </Button>
      </div>
    );
  }

  renderDisableFooter() {
    return (
      <div className={s.footer}>
        {!this.props.cantClose && (
          <Button color="text" onClick={this.props.onCancel}>
            button.cancel
          </Button>
        )}

        <Button color="red" loading={this.otpState.verifingOTP} onClick={() => this.verify("disable")}>
          button.disable
        </Button>
      </div>
    );
  }

  renderEnabledMsg() {
    return (
      <div className={s.wrapDisable}>
        <div className={s.text}>
          <TranslatedString>modal.otp.disable.desc</TranslatedString>
        </div>
        <Pin
          label={t("input.label.otpCode")}
          onSubmit={() => this.verify("disable")}
          ref={(pin) => (this.pin = pin)}
          length={6}
          errors={this.otpState.invalidOTP}
        />
      </div>
    );
  }

  renderSecret(emailAddress) {
    const secret = this.otpState.secret;
    let url = `otpauth://totp/${emailAddress}?secret=${secret}&issuer=Qbpanel`;

    if (this.props.user.type) {
      url = url + "-" + this.props.user.type;
    }

    return (
      <div className={s.wrapSecret}>
        <div className={s.text}>
          <TranslatedString>modal.otp.enable.desc</TranslatedString>{" "}
        </div>
        <div className={s.qrCpode}>
          <QRCodeCanvas value={url} />
        </div>
        <div className={s.wrapCode}>
          <div className={s.textCode}>
            {t("detailInfo.label.code")}: <code>{secret}</code>
          </div>
          <div
            className={cx(s.generateCode, { [s.newCode]: this.otpState.generatingSecret })}
            onClick={this.generateSecret}
          >
            {this.otpState.generatingSecret ? t("infoMsg.code.newGeneration") : t("button.regenerate.code")}
          </div>
        </div>
        <Pin
          className={s.pin}
          label={t("input.label.otpCode")}
          onSubmit={() => this.verify("enable")}
          ref={(pin) => (this.pin = pin)}
          length={6}
          errors={this.otpState.invalidOTP}
        />
      </div>
    );
  }

  render() {
    const otp = this.props.user.otp;
    let body, header, footer;

    // OTP is not active but there is not secret yet (first time using OTP)
    if (!otp && !this.otpState.secret) {
      body = this.renderGoogleAuth();
      footer = this.renderGoogleAuthFooter();
    }


    // OTP is not active
    if (!otp && this.otpState.secret) {
      body = this.renderSecret(this.props.user.email_address);
      footer = this.renderEnableFooter();
    }

    // OTP is active
    if (otp) {
      body = this.renderEnabledMsg();
      footer = this.renderDisableFooter();
    }

    return (
      <div className={s.otpConfig}>
        {/*header*/}
        {body}
        {footer}
      </div>
    );
  }
}

// const mapStateToProps = state => ({
//   otpSecret: state.resources.otpSecret,
//   otp: state.otp,
//   secret: state.otp.secret,
//   isValidOTP: state.otp.isValid,
//   isOTPEnabled: state.otp.isOTPEnabled,
//   isVerifing: state.otp.isVerifing,
//   regeneratingSecret: state.otp.isGeneratingSecret
// });

// const mapDispatchToProps = dispatch => ({
//   generateSecret: code => {
//     dispatch(otpActions.generatingSecret(code));
//   },

//   verifyOTP: (code, formValues) => {
//     dispatch(otpActions.verifyOTP(code, formValues));
//   },

//   deleteOTPSessionToken: (code, id) => dispatch(otpActions.deleteOTPSessionToken(code, id))
// });

export default view(OtpConfig);
